import { render, staticRenderFns } from "./SalesAndLosses.vue?vue&type=template&id=63cf9750"
import script from "./SalesAndLosses.vue?vue&type=script&lang=js"
export * from "./SalesAndLosses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports